var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrapper"},[_c('button',_vm._g(_vm._b({staticClass:"DButton"},'button',_vm.props,false),_vm.$listeners),[_vm._t("default")],2),_c('div',{staticClass:"background"})])}
var staticRenderFns = []

export { render, staticRenderFns }